import type { UserInfoApiResponse } from './types';

/**
 * Derive whether the current user is an account admin from the raw
 * `/v1/authn/userinfo` payload. Prefers the explicit top-level `is_admin`,
 * falling back to the active account role (`account-admin`).
 *
 * This is the single source of truth for the admin gate on admin-only builder
 * surfaces (e.g. snippet authoring). The server also enforces it (403s
 * non-admins), so the client gate is defense-in-depth.
 */
export const isAdminFromUserInfo = (
  userInfo: Pick<UserInfoApiResponse, 'is_admin' | 'active_account_user'>
): boolean =>
  userInfo.is_admin === true ||
  userInfo.active_account_user?.role_id === 'account-admin';
